import React from 'react';
import { useUfService } from '../services/uf-service';

export const useUfController = () => {
  const { recoverUfs } = useUfService();
  const [listUfs, setListUfs] = React.useState([]);

  const getUfs = React.useCallback(
    (labelIsUf = false) => {
      return recoverUfs()
        .then((data) => {
          let listUfs = data?.map((uf) => ({
            id: uf.id,
            label: labelIsUf ? uf.initials : uf.name,
            sigla: uf.initials,
          }));
          setListUfs(listUfs);
          return listUfs;
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
    [recoverUfs],
  );

  const returnSiglaById = React.useCallback(
    (id) => {
      if (!id) return [];
      const { sigla } = listUfs.find((uf) => uf.id === id);
      return sigla;
    },
    [listUfs],
  );

  const returnUfBySigla = React.useCallback(
    (uf) => {
      if (!uf) return [];
      const ufFinded = listUfs.find((uf) => uf.sigla === uf);
      return ufFinded;
    },
    [listUfs],
  );

  return {
    listUfs,
    getUfs,
    returnSiglaById,
    returnUfBySigla,
  };
};
